import { createSlice } from "@reduxjs/toolkit";
import {
  POSType_Enum,
  SalePaymentMethod_Enum,
} from "services/sale/common/enums";
import { IdCaption, Point } from "services/sale/common/types";

export interface ConsoleSettingState {
  unitId: string;
  pcPoseTypes: Array<POSType_Enum>;
  sourceDefualtTerminal: IdCaption;
  mapCenterLocation: Point;
  sourceDefaultPickupLocation: SourceDefaultPickupLocationModel;
  salePaymentMethods: SalePaymentMethod_Enum[];
  consoleSettingSuccess: boolean;
  logo: string;
  supportTells: string;
  maxRequestDateTime: number;
  waitForPayDateTime: number;
  waitForPrintTicketDateTime: number;
}

export interface SourceDefaultPickupLocationModel {
  caption: string;
  id: number;
  point: Point;
}

export const consoleSettingSlice = createSlice({
  name: "consoleSetting",
  initialState: {} as ConsoleSettingState,
  reducers: {
    updateData: (state, action) => {
      state = {
        ...state,
        ...action.payload,
      };

      return state;
    },

    clearData: (state, action) => {
      state = {} as ConsoleSettingState;
      return state;
    },
  },
});
